import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import {
  ColumnSeries,
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  Legend,
  Category,
  Tooltip,
  DataLabel,
  StackingBarSeries,
  Chart,
} from "@syncfusion/ej2-react-charts";
import { priceDisplay } from "../../Constants/CommonConstant";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

class CleanupPdf extends Component {
  constructor(props) {
    super(props);
    this.state = {
      providerName: "",
      loggedInUser: "",
      currentDateTime: 0,
      value: undefined,
      reportDataPayload:
        this.props.location.state.data !== undefined
          ? this.props.location.state.data
          : [],
      modalLoader: false,
      errorPopup: false,
      errormessage: "",
      isErrorHeader: false,
      isFreeTrial: false,
      chartLeftImage: "",
      chartRightImage: "",
      isShowDetails: false,
      currentDs: undefined,
      resourceTypePalette: [
        "#C8FFFF",
        "#007FFF",
        "#C8C8C8",
        "#646464",
        "#3200FF",
        "#00007F",
      ],
      costPalett: ["#C4C3C3", "#2500A1"],
      legendSettings: {
        visible: true,
        position: "Bottom",
        margin: { top: 20 },
        textStyle: {
          size: window.innerWidth < 767 ? "14px" : "20px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        alignment: "Center",
        toggleVisibility: false,
      },
      legendSettingsProcess: {
        visible: true,
        position: "Bottom",
        margin: { top: 20 },
        textStyle: {
          size: window.innerWidth < 767 ? "14px" :"22px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        alignment: "Center",
        toggleVisibility: false,
      },
      titleStyle: {
        color: "#393939",
        size: "20px",
        fontWeight: "bold",
        location: { x: "277", y: "26.5" },
      },
      marker: {
        dataLabel: {
          position: "Auto",
          visible: true,
          font: {
            color: "white",
            size: "20px",
            fontFamily: "Poppins, sans-serif",
            fontWeight: "500",
          },
        },
      },
      costPerfMarker: {
        dataLabel: {
          position: "Outer",
          visible: true,
          font: {
            color: "#393939",
            size: window.innerWidth < 767 ? "16px" : "20px",
            fontFamily: "Poppins, sans-serif",
            fontWeight: "500",
          },
        },
      },
      costxAxis: {
        valueType: "Category",
        labelStyle: {
          size: "20px",
          fontWeight: "500",
          color: "#808080",
          fontFamily: "Poppins, sans-serif",
        },
      },
      costyAxis: {
        title: "Monthly Cost Run Rate",
        labelStyle: {
          size: "20px",
          fontWeight: "500",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
        titleStyle: {
          size: window.innerWidth < 767 ? "16px" : "20px",
          fontWeight: "400",
          fontFamily: "Poppins, sans-serif",
          color: "#393939",
        },
      },
      chartTitleStyle: {
        color: "#393939",
        fontWeight: "500",
        size: "20px",
        fontFamily: "Poppins, sans-serif",
      },
      progressxAxis: {
        valueType: "Category",
        labelStyle: {
          size: "20px",
          fontWeight: "500",
          color: "#808080",
          fontFamily: "Poppins, sans-serif",
        },
      },
      progressyAxis: {
        labelFormat: "{value}%",
        minimum: 0,
        maximum: 100,
        interval: 25,
        labelStyle: {
          size: "20px",
          fontWeight: "400",
          color: "#393939",
          fontFamily: "Poppins, sans-serif",
        },
      },
    };
  }

  async componentDidMount() {
    let responseJson = this.props.clientSidePdfData;
    if (responseJson) {
      if (responseJson.success === true && responseJson.data !== undefined) {
        if (
          responseJson.data.costGraph !== undefined &&
          responseJson.data.costGraph.costChart !== undefined
        ) {
          let mxCost = Math.max.apply(
            Math,
            responseJson.data.costGraph.costChart.map(function (o) {
              return o.current_cost;
            })
          );
          let interval = Math.round(mxCost / 4);

          await this.setState({
            costyAxis: {
              interval: interval,
              maximum: mxCost + interval,
              minimum: 0,
            },
          });
        }

        //      Progress Chart
        let order = {
          percent_unanalyzed: "#6848D2",
          percent_analyzed: "#2500A1",
          percent_analysis_ineligible: "#D9CEFF",
          percent_analysis_error: "#A489FF",
          percent_optimized: "#00A17A",
          percent_custom_sized: "#26DAAE",
        };

        let label = {
          percent_unanalyzed: "Unanalyzed",
          percent_analyzed: "Analyzed",
          percent_analysis_ineligible: "Analysis Ineligible",
          percent_analysis_error: "Analysis Issue",
          percent_optimized: "Optimally Cleaned",
          percent_custom_sized: "Custom Cleaned",
        };

        let keysSorted = Object.keys(
          responseJson.data.progressGraph.progressList[0]
        ).sort((a, b) => {
          return Object.keys(order).indexOf(a) - Object.keys(order).indexOf(b);
        });
        let fiterData = [];
        let data = responseJson.data.progressGraph.progressList[0];

        keysSorted.map((value) => {
          if (
            parseInt(data[value]) !== 0 &&
            data[value] !== null &&
            value.startsWith("percent_")
          ) {
            let obj1 = {
              type: "StackingBar",
              dataSource: [
                {
                  resourceName: data.resourceName,
                  [value]: data[value],
                  [`actual_${value}`]: data[`actual_${value}`],
                },
              ],
              xName: "resourceName",
              yName: value,
              name: label[value],
              legendShape: "Rectangle",
              fill: order[value],
              marker: {
                dataLabel: {
                  visible: true,
                  font: { size: "22px", fontFamily: " Poppins, sans-serif" },
                },
              },
            };
            fiterData.push(obj1);
          }
        });

        Chart.Inject(
          Chart,
          StackingBarSeries,
          Category,
          Tooltip,
          Legend,
          DataLabel
        );

        let chart = new Chart({
          //Initializing Primary X Axis
          primaryXAxis: {
            valueType: "Category",
            labelStyle: {
              size: window.innerWidth < 767 ? "14px" : "22px",
              fontWeight: "500",
              color: "#808080",
              fontFamily: "Poppins, sans-serif",
            },
          },
          //Initializing Primary Y Axis
          primaryYAxis: {
            minimum: 0,
            maximum: 100,
            interval: 25,
            labelStyle: {
              size: window.innerWidth < 767 ? "14px" : "22px",
              fontWeight: "400",
              color: "#393939",
              fontFamily: "Poppins, sans-serif",
            },
            labelFormat: "{value}%",
          },
          chartArea: {
            border: {
              width: 1,
            },
          },
          series: fiterData,
          legendSettings: this.state.legendSettingsProcess,
          height: "300",
          title: "",
          titleStyle: this.state.chartTitleStyle,
          palettes: this.state.resourceTypePalette,
          pointRender: this.progressBarPointRenderer,
          axisLabelRender: this.axisLabelRender,
          marker: this.state.marker,
        });
        chart.appendTo("#renderProgressChart");

        //     End Progress Chart

        await this.setState({
          value: responseJson.data,
          modalLoader: false,
          isFreeTrial: responseJson.orgInfo.plan === "FREE_TRIAL",
          providerName: responseJson.orgInfo.providerName,
          currentDateTime: responseJson.orgInfo.currentDateTime,
          loggedInUser: responseJson.orgInfo.loggedInUser,
        });
      }
    }
  }

  axisLabelRender = (args) => {
    if (!isNaN(args.value) && !isNaN(args.axis.endLabel)) {
      args.text = "";
    }
  };

  axisPointRender = (args) => {
    args.point.y = parseFloat(args.point.y).toFixed(2);
    args.point.text = priceDisplay(
      args.point.y,
      this.state.value?.userCurrency
    );
  };

  progressBarPointRenderer = (args) => {
    console.log(args);
    if (args.point.y == 0) {
      args.cancel = true;
    } else {
      var text = "actual_" + args.series.properties.yName;
      if (
        args.series.properties.dataSource[0][text] !== undefined &&
        args.series.properties.dataSource[0][text] !== null
      ) {
        args.point.yValue = args.series.properties.dataSource[0][text];
      }
    }
  };

  render() {
    return (
      <div>
        <div
          className="container-verf container-verf-padding"
          role="main"
          style={{ marginTop: "50px" }}
        >
          <div className="container1 boxShadow">
            <div
              id="cleanup_list_account"
              style={{ width: "100%", justifyContent: "space-between" }}
            >
              <div
                className="reportChart"
                style={{ padding: "0px", width: "100%", paddingBottom: "40px" }}
              >
                <div id="LeftCleanupChart">
                  <Row
                    id="costCleanupChart"
                    style={{ justifyContent: "center" }}
                  >
                    <Col sm="10">
                      <ChartComponent
                        id="ccchart"
                        axisLabelRender={this.axisLabelRender}
                        pointRender={this.axisPointRender}
                        primaryXAxis={this.state.costxAxis}
                        primaryYAxis={this.state.costyAxis}
                        title={""}
                        titleStyle={this.state.chartTitleStyle}
                        palettes={this.state.costPalett}
                        legendSettings={this.state.legendSettings}
                      >
                        <Inject
                          services={[ColumnSeries, Legend, DataLabel, Category]}
                        />
                        <SeriesCollectionDirective>
                          <SeriesDirective
                            dataSource={
                              this.state.value !== undefined
                                ? this.state.value.costGraph.costChart
                                : []
                            }
                            xName="type"
                            yName="current_cost"
                            name="Current Cost"
                            type="Column"
                            columnWidth="0.9"
                            marker={this.state.costPerfMarker}
                          ></SeriesDirective>
                          <SeriesDirective
                            dataSource={
                              this.state.value !== undefined
                                ? this.state.value.costGraph.costChart
                                : []
                            }
                            xName="type"
                            yName="reduced_cost"
                            name="Post-Cleanup Cost"
                            type="Column"
                            columnWidth="0.9"
                            marker={this.state.costPerfMarker}
                          ></SeriesDirective>
                        </SeriesCollectionDirective>
                      </ChartComponent>
                    </Col>
                  </Row>
                  <Row
                    id="progressCleanupChart"
                    style={{ justifyContent: "center" }}
                  >
                    <Col sm="9">
                      <div id="renderProgressChart"></div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    companyDetails: state.companyDetails.data,
  };
};

export default connect(mapStateToProps, null)(withRouter(CleanupPdf));
